import { render, staticRenderFns } from "./MsgTypeSelect.vue?vue&type=template&id=d15997c6&"
import script from "./MsgTypeSelect.vue?vue&type=script&lang=js&"
export * from "./MsgTypeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports